import { isDevMode } from '@angular/core';
import type { MecapEnvironment } from '../environment/type';
import { defaultMecapEnv } from '../mecap/default';

export const environment = {
  ...defaultMecapEnv,
  applicationName: 'DEV',
  isAngularDevMode: isDevMode(),

  googleMapsApiKey: 'AIzaSyBIVk1MrShNeH3eumzyUyBCNAuBkq0v_hM',
} as const satisfies MecapEnvironment;
